import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SentryErrorHandler, addBreadcrumb } from '@sentry/angular';

@Injectable()
export class CustomSentryHandler extends SentryErrorHandler {
  #router = inject(Router);

  override handleError(error: any): void {
    // Add custom logic here
    const errorMessage = error?.message;
    if (errorMessage && errorMessage.includes('NG04002: Cannot match any routes.')) {
      addBreadcrumb({
        category: 'navigation',
        message: `Navigation error: Cannot match any routes. ${errorMessage}`,
        level: 'warning',
      });
      this.#router.navigate(['/']); // Redirect to initial route
      return; // Skip sending this error to Sentry
    }

    super.handleError(error); // Sentry default behavior
  }
}
